import { useCallback, useRef, useState } from 'react';
import { useUnsavedChangesHandlers } from '../../../utils/use-unsaved-changes-handlers';
import { getNextRuleElementIndex } from './rule-element-navigation-utils';
const NEW_ELEMENT_EXPAND_DELAY = 500;
const PREV_ELEMENT_COLLAPSE_DELAY = 500;
export const useElementToggle = () => {
  const [selectedElementId, setSelectedElementId] = useState(null);
  const unsavedChangesHandlers = useUnsavedChangesHandlers();
  const selectedElementIdRef = useRef(null);
  selectedElementIdRef.current = selectedElementId;
  const [previousOpenElementId, setPreviousOpenElementId] = useState(null);
  const collapseElement = useCallback(() => {
    setSelectedElementId(null);
  }, []);
  const openNextElement = useCallback((elements, openElement, handleCollapseAnimationEnd) => {
    const selectedElementIndex = elements.findIndex(element => element.id === selectedElementIdRef.current);
    if (selectedElementIndex !== -1) {
      const nextElementIndex = getNextRuleElementIndex(elements, selectedElementIndex);
      setPreviousOpenElementId(selectedElementIdRef.current);
      setSelectedElementId(null);
      setTimeout(() => {
        setPreviousOpenElementId(null);
        handleCollapseAnimationEnd();
        const nextElement = elements[nextElementIndex ?? -1];
        if (nextElement) {
          setTimeout(() => {
            openElement(nextElement);
            setSelectedElementId(nextElement.id);
          }, NEW_ELEMENT_EXPAND_DELAY);
        }
      }, PREV_ELEMENT_COLLAPSE_DELAY);
    } else {
      handleCollapseAnimationEnd();
    }
  }, [setSelectedElementId, setPreviousOpenElementId]);
  const toggleElement = useCallback((elementId, onOpenElement) => () => {
    if (elementId !== selectedElementIdRef.current) {
      var _unsavedChangesHandle;
      if (unsavedChangesHandlers != null && (_unsavedChangesHandle = unsavedChangesHandlers.navigationGuard) != null && _unsavedChangesHandle.exists) {
        unsavedChangesHandlers.navigationGuard.onNavigationAttempt(() => {
          setSelectedElementId(elementId);
          onOpenElement();
        });
      } else if (unsavedChangesHandlers != null && unsavedChangesHandlers.unsavedChanges.exists) {
        const handleApply = unsavedChangesHandlers.unsavedChanges.apply;
        unsavedChangesHandlers.showSaveBeforeLeaveModal(handleApply, () => {
          unsavedChangesHandlers.unsavedChanges.discard == null || unsavedChangesHandlers.unsavedChanges.discard();
          unsavedChangesHandlers.setUnsavedChanges(false, async () => {});
          setSelectedElementId(elementId);
          onOpenElement();
        });
      } else {
        setSelectedElementId(elementId);
        onOpenElement();
      }
    } else {
      var _unsavedChangesHandle2;
      if (unsavedChangesHandlers != null && (_unsavedChangesHandle2 = unsavedChangesHandlers.navigationGuard) != null && _unsavedChangesHandle2.exists) {
        unsavedChangesHandlers.navigationGuard.onNavigationAttempt(() => {
          collapseElement();
        });
      } else if (unsavedChangesHandlers != null && unsavedChangesHandlers.unsavedChanges.exists) {
        const handleApply = unsavedChangesHandlers.unsavedChanges.apply;
        unsavedChangesHandlers.showSaveBeforeLeaveModal(handleApply, () => {
          unsavedChangesHandlers.unsavedChanges.discard == null || unsavedChangesHandlers.unsavedChanges.discard();
          unsavedChangesHandlers.setUnsavedChanges(false, async () => {});
          collapseElement();
        });
      } else {
        collapseElement();
      }
    }
  }, [collapseElement, unsavedChangesHandlers]);
  return {
    collapseElement,
    openNextElement,
    previousOpenElementId,
    selectedElementId,
    toggleElement
  };
};
//# sourceMappingURL=use-element-toggle.js.map